<script lang="ts">
    import { onMount } from 'svelte/internal'
    import LoginForm from './login-form.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'

    let step = 1 // 1 = login, 2 = confirmar acesso, 3 = redirecionando
    let show = false
    let clientId = ''
    let redirectUri = ''
    let state = ''
    let codeChallenge = ''
    let codeChallengeMethod = ''
    let resource = ''

    onMount(() => {
        const url = new URL(location.href)
        clientId = url.searchParams.get('client_id') || ''
        redirectUri = url.searchParams.get('redirect_uri') || ''
        state = url.searchParams.get('state') || ''
        codeChallenge = url.searchParams.get('code_challenge') || ''
        codeChallengeMethod = url.searchParams.get('code_challenge_method') || ''
        resource = url.searchParams.get('resource') || ''

        if (!clientId || !redirectUri || !codeChallenge) {
            window.error('Link de autorização inválido ou incompleto.')
            return
        }

        step = window.api.users.auth.isValid() ? 2 : 1
    })

    function onLoginSuccess() {
        step = 2
    }

    async function authorize() {
        try {
            show = true
            const result = await window.api.users.oauth.authorizeComplete({
                client_id: clientId,
                redirect_uri: redirectUri,
                state,
                code_challenge: codeChallenge,
                code_challenge_method: codeChallengeMethod,
                resource,
            })
            step = 3
            location.href = result.redirectUri
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }
</script>

<main class="root">
    <div class="in">
        <div class="box pub">
            <div class="-ilustration mb-3 text-center">
                <img src="/img/sign.png" alt="" />
            </div>
            <span class="e-1 mt-2 mb-2"><b>Autorizar</b> acesso</span>
        </div>
        <div class="box form">
            <div>
                <div class="-logo mb-3 text-center">
                    <img class="mb-3" src="/img/logo_white.png" alt="" />
                </div>
                {#if step === 1}
                    <p class="text-white text-center mb-3">Faça login para autorizar o acesso à sua conta Zandu.</p>
                    <LoginForm on:success={onLoginSuccess} />
                {:else if step === 2}
                    <p class="text-white text-center mb-3">
                        Um assistente está solicitando acesso à sua conta Zandu. Só autorize se você reconhece e confia
                        em quem está pedindo.
                    </p>
                    <button class="btn btn-primary w-100" on:click={authorize}>Autorizar acesso</button>
                {:else if step === 3}
                    <p class="text-white text-center">Redirecionando...</p>
                {/if}
            </div>
        </div>
    </div>
    <LoadSpinner {show} />
</main>

<style>
    .e-1 {
        font-weight: 300;
        font-size: 24px;
        display: inline-block;
    }
    .e-1 b {
        font-weight: 300;
        background: orange;
    }

    .root {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
        width: 100vw;
        background: url('/img/bg_login.png') #333333 center center no-repeat;
        background-size: auto;
    }
    .root .-ilustration {
        overflow: hidden;
    }
    .root .-ilustration img {
        max-height: 240px;
        max-width: 80vw;
    }
    .root .in {
        background: rgba(0, 0, 0, 0.4);
        border-radius: 16px;
        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);
        backdrop-filter: blur(15px);
        -webkit-backdrop-filter: blur(15px);
        border: 1px solid rgba(0, 0, 0, 0.06);
        flex: 0 1 960px;
        max-height: 100vh;
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
        margin: 8px;
    }
    .in .box {
        min-height: 360px;
    }
    .in .pub {
        background-color: white;
        padding: 16px 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .in .form {
        padding: 16px 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-grow: 1;
    }
    .in .form > div {
        flex-grow: 1;
        max-width: 380px;
    }

    @media (max-width: 900px) {
        .in .pub {
            display: none;
        }
    }
</style>
